class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.classList.contains('search-input')) {
        this.handleSearch(event);
      } else if (this.classList.contains('slider')) {
        this.onClickHandler(event);
      } else {
        this.onSubmitHandler(event);
      }
    }, 200);
    const deviceWidth = new DeviceWidth()
    this.isMobile = !deviceWidth.isDesktop

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('click', this.updateDetails.bind(this));
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    subscribe(PUB_SUB_EVENTS.updateFacets, () => {
      FacetFiltersForm.detailsToggle(true);
    });
  }

  onClickHandler(event) {
    const currentInput = event.target;
    const facetsSidebar = document.getElementById('facets-sidebar');

    const selectedFacet = Array.from(
      facetsSidebar.querySelectorAll('.no-js-hidden input[name="' + currentInput.name + '"]')
    ).find((element) => element.value == currentInput.value);

    selectedFacet?.click();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  updateDetails(event) {
    if(event.target.classList.contains('facets__summary')) {
      if(event.target.closest('.js-filter')) event.target.closest('.js-filter').toggleAttribute('open')
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    if (countContainer) {
      countContainer.classList.add('loading');
    }

    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderFacetsCount(html);
        FacetFiltersForm.renderCollectionTitle(html);
        FacetFiltersForm.renderLoadMore(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        
      })
      .catch(error => console.log(error))
      .finally(() => {
        publish(PUB_SUB_EVENTS.updateFacets)
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderCollectionTitle(html);
    FacetFiltersForm.renderFacetsCount(html);
    FacetFiltersForm.renderLoadMore(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    publish(PUB_SUB_EVENTS.updateFacets)
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    if (parsedHTML.getElementById('ProductGridContainer')) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('ProductGridContainer').innerHTML;

      document
        .getElementById('ProductGridContainer')
        .querySelectorAll('.scroll-trigger')
        .forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
        });
    }
  }

  static renderLoadMore(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    if (parsedHTML.getElementById('product-grid-pagination')) {
      document.getElementById('product-grid-pagination').innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('product-grid-pagination').innerHTML;
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').querySelector('.ProductCount');
   
    if (!count) return;
    const container = document.querySelector('.ProductCount');
    const containerDesktop = document.querySelector('.ProductCountDesktop');
   
    container.innerHTML = count.innerHTML;
    container.classList.remove('loading');
    

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFacetsCount(html) {
    const facetsCount = new DOMParser().parseFromString(html, 'text/html').querySelector('.FacetsCounter');
    if (!facetsCount) return;
    const container = document.querySelector('.FacetsCounter');
    const containerDesktop = document.querySelector('.FacetsCounterDesktop');
    container.innerHTML = facetsCount.innerHTML;

    if (containerDesktop) {
      containerDesktop.innerHTML = facetsCount.innerHTML;
    }
  }

  static renderCollectionTitle(html) {
    const collectionTitle = new DOMParser().parseFromString(html, 'text/html').querySelector('.collectionTitle');
    if (!collectionTitle) return;
    const container = document.querySelector('.collectionTitle');
    container.innerHTML = collectionTitle.innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersFormSlider .js-filter'
    );

    const activeFacetsWrapper = parsedHTML.querySelector('.active-facets__wrapper');
    if (activeFacetsWrapper) {
      document.querySelector('.active-facets__wrapper').innerHTML = activeFacetsWrapper.innerHTML;
    }

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements); // .filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event.target.closest('.js-filter'))
      FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    const facetSlider = document.querySelector('.facet-slider-carousel');
    facetSlider && new Splide(facetSlider).mount();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
      {
        section: document.getElementById('facets-sidebar').dataset.id,
      },
    ];
  }

  createSearchParams(formData) {
    this.handleLevels(formData);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
   

    if(!this.isMobile) {
     window.scrollY > 0 &&  document.querySelector('.sidebar').scrollIntoView({ behavior: "smooth"})
    } else {
      window.scrollY > 0 &&  window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const formData = new FormData(event.target.closest('form'));
      const searchParams = this.createSearchParams(formData);
      return this.onSubmitForm(searchParams, event);
    }
    const forms = [];
    sortFilterForms.forEach((form) => {
      if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
        const formData = new FormData(form);
        const searchParams = this.createSearchParams(formData);
        if (searchParams != '') {
          if (!forms.includes(searchParams)) {
            forms.push(searchParams);
          }
        }
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  handleLevels(searchParams) {
    const hasCategory = document.querySelector('[name="filter.p.m.elastick.department"]');
    const hasType = document.querySelector('[name="filter.p.product_type"]');

    if (hasCategory) {
      if (!searchParams.has('filter.p.m.elastick.department')) {
        searchParams.delete('filter.p.product_type');
        searchParams.delete('filter.p.m.elastick.micro-category');
      }
    }

    if (!hasCategory && hasType) {
      if (!searchParams.has('filter.p.product_type')) {
        searchParams.delete('filter.p.m.elastick.micro-category');
      }
    }

    return searchParams;
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    const urlParams = new URLSearchParams(window.location.search);

    const attribute = event.currentTarget.dataset.attribute;

    if (attribute === 'all') {
      const url =
        event.currentTarget.href.indexOf('?') == -1
          ? ''
          : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      return FacetFiltersForm.renderPage(url);
    }

    const paramValueToRemove = event.currentTarget.dataset.value;

    const filteredParams = Array.from(urlParams.entries()).filter(
      ([name, value]) => !(name === attribute && value === paramValueToRemove)
    );

    // Construct the new URL search parameters
    const newSearchParams = new URLSearchParams(filteredParams);

    FacetFiltersForm.renderPage(this.handleLevels(newSearchParams).toString());
  }

  handleSearch(event) {
    let searchValue, filterList, filterListElements;
    const facetsDisplaySidebar = event.target.parentElement.closest('.facets-wrap');

    searchValue = event.target.value.toLowerCase();
    filterList = event.target.closest('fieldset').querySelector('ul');
    filterListElements = filterList.getElementsByTagName('li');
    let counter = parseInt(Array.from(filterListElements).length);
    Array.from(filterListElements).forEach((li) => {
      const span = li.querySelector('label .value');
      li.style.display = span.innerHTML.toLowerCase().indexOf(searchValue) > -1 ? '' : 'none';
      counter = span.innerHTML.toLowerCase().indexOf(searchValue) > -1 ? counter : counter - 1;
    });

    if (counter < 12) {
      if (facetsDisplaySidebar) facetsDisplaySidebar.classList.remove('scroll-container');
    } else {
      if (facetsDisplaySidebar) facetsDisplaySidebar.classList.add('scroll-container');
    }
  }


  static handleOpenFacets(searchParams, facetForm) {
    if (!searchParams.length) return
      const params = new URLSearchParams(searchParams)
    for (const [key, value] of params) {
      facetForm.querySelectorAll('.js-filter').forEach(element => {
        if(element.dataset.filter == key) {
          const details = element.querySelector('.facets__disclosure-sidebar')
          details.setAttribute('open', null)
        }
      });
    }
  }

  static detailsToggle(update = false) {
    let searchParams = window.location.search
    const facetForm = document.getElementById('FacetFiltersForm');
    if(!facetForm) return;
    const detailsOpened = Array.from(facetForm.querySelectorAll('.js-filter')).filter(element => element.hasAttribute('open'));
    if(!detailsOpened.length  && !update) {
      return this.handleOpenFacets(searchParams, facetForm )
    }
    if (!searchParams.length) return
    const params = new URLSearchParams(searchParams)
    params.delete("sort_by");
    if(params.size > 0) {
      facetForm.querySelectorAll('.js-filter').forEach(element => {
        const details = element.querySelector('.facets__disclosure-sidebar')
        if(details) {
          element.hasAttribute('open') ? details.setAttribute('open', null) : details.removeAttribute('open')
        }
      });
    } else {
      facetForm.querySelectorAll('.js-filter').forEach(element => {
        const details = element.querySelector('.facets__disclosure-sidebar')
        if(details) {
          element.removeAttribute('open')
          details.removeAttribute('open')
        }
      });
    }

  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.detailsToggle();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetsSidebar extends HTMLElement {
  constructor() {
    super();
    this.sidebar = document.querySelector('.sidebar');
    this.headerSidebar = document.querySelector('.sidebar--header');

    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('.summary__title');
    this.mobileTrigger = this.querySelector('.mobile-facets__open');
    const deviceWidth = new DeviceWidth()
    this.isMobile = !deviceWidth.isDesktop
    this.bindEvents();
  }

  connectedCallback() {
   this.listOverlay();
   this.checkActiveFilters();
    document.documentElement.style.setProperty('--header-height', `${this.headerSidebar.offsetHeight}px`);
  }

  checkActiveFilters() {
    if(document.body.classList.contains('template-collection') && !document.body.classList.contains('facets-opened')) {
      const summaryMobile = document.querySelector('.mobile-facets__open .summary__title');
      document.querySelector('.mobile-facets__open .summary__title .summary__text').innerHTML = summaryMobile.dataset.open;
      document.querySelector('.mobile-facets__open .details-summary').classList.remove('apply-filters')
      document.querySelector('.mobile-facets__open').style.visibility = 'visible';
    }
  }

  listOverlay() {
    const list = this.details.querySelectorAll('ul')
    list.forEach((elem, index) => {
      const parent = elem.closest('.scroll-container');
      if(elem.offsetHeight >= 400) { // List max height 400px
        if(parent) parent.querySelector('.overlay').style.opacity = 0.75;
      }

      elem.addEventListener('scroll', () => {
        if(elem.scrollHeight - elem.scrollTop == elem.offsetHeight) { 
           if(parent) parent.querySelector('.overlay').style.opacity = 0;
        } else {
          if(parent) parent.querySelector('.overlay').style.opacity = 0.75;
        }
        if(elem.scrollTop > 0 && elem.scrollTop < elem.scrollHeight) {
          if(parent) parent.querySelector('.overlay-top').style.opacity = 0.75;
        } else {
          if(parent) parent.querySelector('.overlay-top').style.opacity = 0;
        }
      })
    });
  }

  bindEvents() {
    const summaryMobile = document.querySelector('.mobile-facets__open .summary__title');
    const detailsTitle = this.summary.querySelector('.summary__text');
    this.mobileTrigger.addEventListener('click', () => {
      if (this.isMobile) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
     this.details.toggleAttribute('open');
    })

    this.details.addEventListener('toggle', (event) => {

      const isOpen = event.target.hasAttribute('open')
      document.body.classList.toggle('facets-opened', isOpen);

      if (this.isMobile) {
        document.querySelector('.mobile-facets__open .summary__title .summary__text').innerHTML =  isOpen ? summaryMobile.dataset.close : summaryMobile.dataset.open;
        document.querySelector('.mobile-facets__open .details-summary').classList.toggle('apply-filters', !isOpen)
      } else {
        this.summary.classList.toggle('text-as-button', isOpen);
        detailsTitle.innerHTML = isOpen ? this.summary.dataset.close : this.summary.dataset.open;
      }


    });

    subscribe(PUB_SUB_EVENTS.openMenu, () => {
      this.hide();
    });

    subscribe(PUB_SUB_EVENTS.updateFacets, () => {
      this.listOverlay();
    });
  }

   hide() {
    this.details.removeAttribute('open')
  }
}

customElements.define('facets-sidebar', FacetsSidebar);

class FacetSwitcher extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.facets__switcher');
    this.grids = {}
  }

  connectedCallback() {

    this.wrapper.querySelectorAll('.filter-change').forEach((filterElement) => {
      filterElement.addEventListener('click', (event) => {
        event.preventDefault()
        const facetParam = event.target.dataset.facet;
        // Use forEach on the collection of grid elements
        this.wrapper.querySelectorAll('.filter-change').forEach((gridElement) => {
          const gridFacet = gridElement.dataset.facet
          const isActiveFacet = gridFacet === facetParam;

          const facets = this.querySelector(`.facet__display-grid[data-facet="${gridFacet}"]`);
          if (!isActiveFacet) {
            if (facets) {
              this.grids[gridFacet] = facets;
              facets.remove()
            }
          } else {
            this.grids[gridFacet] &&  this.querySelector('.facets__switcher').insertAdjacentElement('afterend', this.grids[gridFacet])
          }

          // Toggle button classes based on whether it's the active facet
          this.wrapper.querySelector(`.button[data-facet="${gridFacet}"]`)
            .classList.toggle('button--primary', isActiveFacet);
          this.wrapper.querySelector(`.button[data-facet="${gridFacet}"]`)
            .classList.toggle('button--secondary', !isActiveFacet);

          // Toggle visibility of grid elements
          this.querySelector(`.facet__display-grid[data-facet="${gridFacet}"]`)?.classList.toggle('visibility-hidden', !isActiveFacet);
        });

      });
    });
  }
}

customElements.define('facets-switcher', FacetSwitcher);


class FacetsSliderComponent extends SplideSliderComponent {
  constructor() {
    super();  
  }

  startSlider() {
    this.splide.mount(this.autoscroll);
    this.bindEvents()
  }
  
  bindEvents() {
    const slidesLength = this.splide.length - 1;
    this.splide.on('active', (slide) => {
      const splideId = this.getAttribute('id')
      const firstSlide = this.querySelector('#' + splideId + '-slide01');
      if(slide.index == slidesLength) {
        this.querySelector('.overlay-right').style.opacity = 0
        if(firstSlide && !firstSlide.classList.contains('is-visible')) {
          this.querySelector('.overlay-left').style.opacity = 1
        }
      } else if(slide.index == 0) {
        this.querySelector('.overlay-right').style.opacity = 1
        this.querySelector('.overlay-left').style.opacity = 0
      } else {
        this.querySelector('.overlay-left').style.opacity = 1
        this.querySelector('.overlay-right').style.opacity = 1
      }
    });
  }
}

customElements.define('facets-slider', FacetsSliderComponent);